'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _svg = require('../../utils/svg.utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var controls = (0, _svg.getSvgControls)();
var Svg = controls.Svg,
    Path = controls.Path;

var Overcast = function (_React$Component) {
    _inherits(Overcast, _React$Component);

    function Overcast() {
        _classCallCheck(this, Overcast);

        return _possibleConstructorReturn(this, (Overcast.__proto__ || Object.getPrototypeOf(Overcast)).apply(this, arguments));
    }

    _createClass(Overcast, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                Svg,
                { width: '26', height: '32', viewBox: '0 0 26 32' },
                _react2.default.createElement(Path, { fill: this.props.fill, d: 'M21.856 16.468c-0.017 0-0.034 0-0.051 0.001-0.342-2.289-2.304-3.991-4.642-3.991-1.989 0-3.784 1.285-4.437 3.15-0.334-0.094-0.682-0.143-1.018-0.143-1.853 0-3.405 1.337-3.695 3.143-0.083-0.008-0.161-0.012-0.238-0.012-1.467 0-2.661 1.195-2.661 2.665 0 1.468 1.194 2.662 2.661 2.662h14.081c2.061 0 3.738-1.676 3.738-3.735 0-2.062-1.677-3.739-3.738-3.739zM21.856 23.523h-14.081c-1.236 0-2.241-1.006-2.241-2.243 0-1.238 1.005-2.245 2.241-2.245 0.115 0 0.237 0.011 0.383 0.036l0.221 0.038 0.023-0.223c0.175-1.7 1.597-2.982 3.306-2.982 0.359 0 0.735 0.064 1.085 0.184l0.207 0.071 0.063-0.209c0.538-1.797 2.224-3.053 4.1-3.053 2.191 0 4.017 1.64 4.25 3.814l0.022 0.205 0.205-0.018c0.076-0.007 0.145-0.011 0.217-0.011 1.83 0 3.318 1.489 3.318 3.32-0 1.828-1.488 3.315-3.318 3.315z' }),
                _react2.default.createElement(Path, { fill: this.props.fill, d: 'M7.135 16.278h-5.102c-0.89 0-1.614-0.725-1.614-1.616 0-0.892 0.724-1.618 1.614-1.618 0.082 0 0.171 0.009 0.275 0.027l0.222 0.039 0.023-0.224c0.127-1.238 1.162-2.172 2.408-2.172 0.262 0 0.535 0.047 0.79 0.135l0.207 0.071 0.063-0.21c0.392-1.315 1.626-2.233 3-2.233 1.602 0 2.94 1.2 3.111 2.791l0.022 0.206 0.206-0.019c0.053-0.005 0.102-0.008 0.154-0.008 0.587 0 1.152 0.212 1.592 0.598l0.277-0.315c-0.514-0.451-1.175-0.7-1.86-0.703-0.279-1.707-1.751-2.97-3.502-2.97-1.487 0-2.83 0.949-3.335 2.333-0.238-0.063-0.481-0.095-0.724-0.095-1.389 0-2.555 0.99-2.795 2.335-0.046-0.004-0.089-0.005-0.132-0.005-1.122-0.001-2.035 0.913-2.035 2.037 0 1.122 0.912 2.035 2.034 2.035h5.101l0-0.419z' })
            );
        }
    }]);

    return Overcast;
}(_react2.default.Component);

Overcast.propTypes = {
    fill: _react2.default.PropTypes.string
};

exports.default = Overcast;


//////////////////
// WEBPACK FOOTER
// ./~/pluton-assets/lib/icons/weather/overcast.js
// module id = 1139
// module chunks = 0